var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#FF4314"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.15869 4.5H12.9302V5.58281H5.15813L5.15869 4.5ZM4.29244 7.67306H13.896V8.76713H10.9541V12.4273C10.9541 12.7086 11.0762 12.8492 11.331 12.8492H12.5527C12.6861 12.8492 12.7969 12.7631 12.8632 12.6006C12.9414 12.4273 12.9966 11.8963 13.0191 11.0194L14.0625 11.3445C13.9849 12.5679 13.8403 13.2936 13.6406 13.5214C13.4409 13.7374 13.1524 13.8566 12.7631 13.8566H10.9986C10.2099 13.8566 9.82181 13.4561 9.82181 12.6653V8.76713H8.17819V8.98369C8.12306 10.359 7.81256 11.4632 7.24612 12.2867C6.69094 13.0444 5.80275 13.6401 4.55906 14.0625L3.9375 13.1096C5.13675 12.6979 5.93606 12.1781 6.35794 11.5718C6.77981 10.9001 7.00144 10.0446 7.04588 8.98369V8.76713H4.293L4.29244 7.67306Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCny);
export default __webpack_public_path__ + "static/media/cny.173e428baecf8a6d1aee67f6af50e078.svg";
export { ForwardRef as ReactComponent };